export const MixOptions = [
    {
        value: '5d11ae9b-4f15-4cc6-bf1e-e51845a01584',
        label: 'None (blank)',
        icon: 'PB'
    },
    {
        value: '07c80e99-5b3c-474d-b94a-34c14214fe5c',
        label: 'Add to Mix Water',
        icon: 'PH'
    },
    {
        value: 'cfb95677-cd4c-4b92-80ab-ff52a1760c70',
        label: 'Add on the Fly',
        icon: 'PM'
    }
]